unit UExportacoes;

interface

uses
  System.SysUtils,
  XData.Web.Dataset,
  Data.DB,
  ConnectionModule,
  WEBLib.Dialogs,
  System.Classes,
  WEBLib.XLSX,
  WEBLib.Grids,
  WEBLib.Forms,
  Web,
  JS,
  libexceljs,
  WEBLib.Controls,
  UUtils,
  WEBLib.DBCtrls,
  XData.Web.Client;

type
  TExportacoes = class
    procedure cdsDadosAfterOpen(DataSet: TDataSet);
    private
    const
      cREGISTROS_PAGINACAO = 1000;
    var
      FCdsDados : TXDataWebDataSet;
      FListaCampos : TStringList;
      FExportacao : TExportacoes;
      FQuantidadeRegistros,
      FRegistrosProcessados : Integer;
      FTextoColunaMesclada : string;

      procedure SetCamposCds(pCdsOrigem : TXDataWebDataSet; pTabela : TDBTableControl);
      function GetFieldProperty(pFieldName : string; pTipo : Boolean) : string;
      procedure CriarPlanilha;
      procedure BaixarPlanilha(pNomeArquivo : string = '');
      procedure FormatarCabecalho;
      function GetJsonAlinharConteudo(pAlinhamento : string) : TJSObject;
      function GetValorFormatado(pValor, pCampo : string) : string;

      function GetNomeColuna(pTabela : TDBTableControl; pCampo : string): string;
      function GetValorFloat(pField : TField; pValor : string) : string;
      procedure ProcessarDados;
      function GetStatusMensagemWhatsApp(pStatus : string) : string;
      function GetStatusDispositivoWhatsApp(pStatus : string) : string;
      procedure SetTextoColunaMesclada;
    public
      constructor Create(pCdsOrigem : TXDataWebDataSet;pTabela : TDBTableControl);
		  destructor Destroy; override;

      procedure ExportarExcel(pFiltro : string; pQuantidadeRegistros : Integer);
      procedure ExportarExcelFaturamento(Response: TXDataClientResponse; pFiltro : string);
      procedure ExportarExcelConfigRetaguarda(const pJsonConfiguracoes, pJsonConfiguracao: string);
      procedure ExportarExcelConfigNfce(const pJsonConfiguracoes: string);
      procedure SetResumoFaturamentoExcel(pJson : TJSObject);
end;

implementation

{ TExportacoes }

procedure TExportacoes.BaixarPlanilha(pNomeArquivo : string);
var
  lNome : string;
begin
  if pNomeArquivo.IsEmpty then
    lNome := 'exportacao_' + FCdsDados.EntitySetName.ToLower + '.xlsx'
  else
    lNome := pNomeArquivo;

  asm
    worksheet.columns.forEach((column) => {
    let maxLength = column.header ? column.header.toString().length : 0; // considerar o header
    column.eachCell({ includeEmpty: true }, (cell) => {
      const cellValue = cell.value ? cell.value.toString() : '';
      if (cellValue.length > maxLength) {
        maxLength = cellValue.length;
      }
    });
    column.width = maxLength + 5; // adicionar padding
    });
  end;

  SetTextoColunaMesclada;

  asm
    workbook.xlsx.writeBuffer().then(function(buffer) {
      saveAs(new Blob([buffer]), lNome);
    });
  end;
end;

procedure TExportacoes.cdsDadosAfterOpen(DataSet: TDataSet);
var
  lCampo : string;
  lRowObj: TJSObject;
  LfIELD : TField;
begin
  FCdsDados.DisableControls;
  FCdsDados.First;
  try
    while not FCdsDados.Eof do
    begin
      lRowObj := TJSObject.new;

      for lCampo in FListaCampos do
      begin
        lRowObj[lCampo] := GetValorFormatado(FCdsDados.FieldByName(lCampo).AsString, lCampo);
      end;

      asm
        worksheet.addRow(lRowObj);
      end;

      FCdsDados.Next;
    end;
  finally
    TUtils.SetMensagemDivLoading(FRegistrosProcessados.ToString + ' registros processados de ' +
      FQuantidadeRegistros.ToString);

    FCdsDados.EnableControls;

    if FRegistrosProcessados >= FQuantidadeRegistros then
    begin
      BaixarPlanilha;
      TUtils.OcultarDivLoading;

      if Assigned(FExportacao) then
        FreeAndNil(FExportacao);
    end
    else
      ProcessarDados;
  end;
end;

constructor TExportacoes.Create(pCdsOrigem : TXDataWebDataSet; pTabela : TDBTableControl);
begin
  TUtils.ChamarDivLoading;
  CriarPlanilha;
  FListaCampos := TStringList.Create;
  FCdsDados := TXDataWebDataSet.Create(nil);
  FCdsDados.EntitySetName := pCdsOrigem.EntitySetName;
  FCdsDados.Connection := DMConnection.ApiConnection;
  SetCamposCds(pCdsOrigem, pTabela);
  FCdsDados.AfterOpen := cdsDadosAfterOpen;

  FExportacao := Self;
  FTextoColunaMesclada := EmptyStr;
end;

procedure TExportacoes.CriarPlanilha;
begin
  asm
    window.workbook = new ExcelJS.Workbook();
    window.worksheet = workbook.addWorksheet('Dados');
  end;
end;

destructor TExportacoes.Destroy;
begin
  if Assigned(FCdsDados) then
    FreeAndNil(FCdsDados);

  if Assigned(FListaCampos) then
    FreeAndNil(FListaCampos);

  asm
    delete window.workbook;
    delete window.worksheet;
  end;

  inherited;
end;

procedure TExportacoes.ExportarExcel(pFiltro: string; pQuantidadeRegistros : Integer);
begin
  TUtils.SetMensagemDivLoading('0 registros processados de ' + pQuantidadeRegistros.ToString);

  if pQuantidadeRegistros = 0 then
    FQuantidadeRegistros := 10000
  else
    FQuantidadeRegistros := pQuantidadeRegistros;

  FCdsDados.Close;
  FCdsDados.QueryString := pFiltro;

  if FQuantidadeRegistros > cREGISTROS_PAGINACAO then
    FCdsDados.QueryTop := cREGISTROS_PAGINACAO
  else
    FCdsDados.QueryTop := FQuantidadeRegistros;

  FRegistrosProcessados := FCdsDados.QueryTop;

  FCdsDados.Load;
end;

procedure TExportacoes.ExportarExcelFaturamento(Response: TXDataClientResponse;
  pFiltro: string);
var
  lJsonArray: TJSArray;
  lIndice : Integer;
  lJsonObject: TJSObject;
  lValor : string;
  lCampo : string;
  lRowObj: TJSObject;
begin
  lJsonArray := TJSArray(Response.ResultAsObject['dados_faturamento']);

  for lIndice := 0 to lJsonArray.Length - 1 do
  begin
    lJsonObject := TJSObject(lJsonArray[lIndice]);
    lRowObj := TJSObject.new;

    for lCampo in FListaCampos do
    begin
      lRowObj[lCampo] := GetValorFormatado(String(lJsonObject[lCampo]), lCampo);
    end;

    asm
      worksheet.addRow(lRowObj);
    end;
  end;

  SetResumoFaturamentoExcel(TJSObject(Response.ResultAsObject['resumo_faturamento']));

  FTextoColunaMesclada := pFiltro;

  BaixarPlanilha('exportacao_faturamento.xlsx');
  TUtils.OcultarDivLoading;

  if Assigned(FExportacao) then
    FreeAndNil(FExportacao);
end;

procedure TExportacoes.ExportarExcelConfigRetaguarda(const pJsonConfiguracoes,
  pJsonConfiguracao: string);
var
  lArrayConfiguracoes,
  lArrayConfiguracao: TJSArray;
  lIndice: Integer;
  lJsonObject,
  lRowObj: TJSObject;
  lNome,
  lDescricao,
  lValor: string;
  lEhBooleano,
  lCentralizarValor: Boolean;

  function GetStringValue(const pObj: TJSObject; const pField: string): string;
  begin
    if isNull(pObj[pField]) or isUndefined(pObj[pField]) then
      Exit('');

    Result := String(pObj[pField]);
  end;

  function GetValorBooleano(const pValor: string): string;
  begin
    if SameText(pValor, '-1') or SameText(pValor, '1') or SameText(pValor, 'TRUE') then
      Result := 'SIM'
    else
      Result := 'NÃO';
  end;

  function GetValorConfiguracao(const pObj: TJSObject; pIsConfiguracao: Boolean): string;
  var
    lValorBruto,
    lTipo,
    lDominio: string;
  begin
    lValorBruto := GetStringValue(pObj, 'valor');

    if pIsConfiguracao then
    begin
      lTipo := GetStringValue(pObj, 'tipo');
      if lTipo = '2' then
        Exit(GetValorBooleano(lValorBruto));
    end
    else
    begin
      lDominio := UpperCase(GetStringValue(pObj, 'dominio'));
      if (lDominio = 'BOOLEAN') or (lDominio = 'BOOL') then
        Exit(GetValorBooleano(lValorBruto));
    end;

    Result := lValorBruto;

    if SameText(Result, 'NULL') then
      Result := '';
  end;

  function IsNumericValue(const pValor: string): Boolean;
  var
    lNumero: Double;
    lTexto: string;
    lFormatSettings: TFormatSettings;
  begin
    lTexto := Trim(pValor);

    if lTexto.IsEmpty then
      Exit(False);

    lFormatSettings := TFormatSettings.Create;
    lFormatSettings.DecimalSeparator := ',';
    lFormatSettings.ThousandSeparator := '.';
    Result := TryStrToFloat(lTexto, lNumero, lFormatSettings);

    if not Result then
    begin
      lFormatSettings.DecimalSeparator := '.';
      lFormatSettings.ThousandSeparator := ',';
      Result := TryStrToFloat(lTexto, lNumero, lFormatSettings);
    end;
  end;

  function IsDateOrDateTimeValue(const pValor: string): Boolean;
  var
    lData: TDateTime;
    lTexto: string;
  begin
    lTexto := Trim(pValor);

    if lTexto.IsEmpty then
      Exit(False);

    Result := TryStrToDateTime(lTexto, lData) or TryStrToDate(lTexto, lData);
  end;

begin
  asm
    worksheet.columns = [
      { header: 'NOME', key: 'nome', style: { alignment: { horizontal: 'left' } } },
      { header: 'VALOR', key: 'valor', style: { alignment: { horizontal: 'left' } } },
      { header: 'DESCRIÇÃO', key: 'descricao', style: { alignment: { horizontal: 'left' } } },
      { header: 'TABELA', key: 'tabela', style: { alignment: { horizontal: 'center' } } }
    ];
  end;

  FormatarCabecalho;

  if Trim(pJsonConfiguracoes).IsEmpty then
    lArrayConfiguracoes := TJSArray.new
  else
    lArrayConfiguracoes := TJSArray(TJSJSON.parse(pJsonConfiguracoes));

  if Trim(pJsonConfiguracao).IsEmpty then
    lArrayConfiguracao := TJSArray.new
  else
    lArrayConfiguracao := TJSArray(TJSJSON.parse(pJsonConfiguracao));

  for lIndice := 0 to lArrayConfiguracoes.Length - 1 do
  begin
    lJsonObject := TJSObject(lArrayConfiguracoes[lIndice]);
    lRowObj := TJSObject.new;

    lNome := UpperCase(GetStringValue(lJsonObject, 'field_name'));
    lDescricao := UpperCase(GetStringValue(lJsonObject, 'description'));
    lValor := GetValorConfiguracao(lJsonObject, False);
    lEhBooleano := (UpperCase(GetStringValue(lJsonObject, 'dominio')) = 'BOOLEAN') or
      (UpperCase(GetStringValue(lJsonObject, 'dominio')) = 'BOOL');
    lCentralizarValor := lEhBooleano or IsNumericValue(lValor) or IsDateOrDateTimeValue(lValor);

    lRowObj['nome'] := lNome;
    lRowObj['valor'] := lValor;
    lRowObj['descricao'] := lDescricao;
    lRowObj['tabela'] := 'CONFIGURAÇÕES';

    asm
      const lNovaLinha = worksheet.addRow(lRowObj);
      if (lCentralizarValor) {
        lNovaLinha.getCell('valor').alignment = { horizontal: 'center' };
      }
    end;
  end;

  for lIndice := 0 to lArrayConfiguracao.Length - 1 do
  begin
    lJsonObject := TJSObject(lArrayConfiguracao[lIndice]);
    lRowObj := TJSObject.new;

    lNome := UpperCase(GetStringValue(lJsonObject, 'nome'));
    lDescricao := UpperCase(GetStringValue(lJsonObject, 'obs'));
    lValor := GetValorConfiguracao(lJsonObject, True);
    lEhBooleano := GetStringValue(lJsonObject, 'tipo') = '2';
    lCentralizarValor := lEhBooleano or IsNumericValue(lValor) or IsDateOrDateTimeValue(lValor);

    lRowObj['nome'] := lNome;
    lRowObj['valor'] := lValor;
    lRowObj['descricao'] := lDescricao;
    lRowObj['tabela'] := 'CONFIGURAÇÃO';

    asm
      const lNovaLinha = worksheet.addRow(lRowObj);
      if (lCentralizarValor) {
        lNovaLinha.getCell('valor').alignment = { horizontal: 'center' };
      }
    end;
  end;

  BaixarPlanilha('exportacao_config_retaguarda.xlsx');
  TUtils.OcultarDivLoading;

  if Assigned(FExportacao) then
    FreeAndNil(FExportacao);
end;

procedure TExportacoes.ExportarExcelConfigNfce(const pJsonConfiguracoes: string);
var
  lArray: TJSArray;
  lIndice: Integer;
  lJsonObject,
  lRowObj: TJSObject;
  lNome,
  lDescricao,
  lValor: string;
  lEhBooleano,
  lCentralizarValor: Boolean;

  function GetStringValue(const pObj: TJSObject; const pField: string): string;
  begin
    if isNull(pObj[pField]) or isUndefined(pObj[pField]) then
      Exit('');

    Result := String(pObj[pField]);
  end;

  function GetValorBooleano(const pValor: string): string;
  begin
    if SameText(pValor, '-1') or SameText(pValor, '1') or SameText(pValor, 'TRUE') then
      Result := 'SIM'
    else
      Result := 'NÃO';
  end;

  function IsNumericValue(const pValor: string): Boolean;
  var
    lNumero: Double;
    lTexto: string;
    lFormatSettings: TFormatSettings;
  begin
    lTexto := Trim(pValor);

    if lTexto.IsEmpty then
      Exit(False);

    lFormatSettings := TFormatSettings.Create;
    lFormatSettings.DecimalSeparator := ',';
    lFormatSettings.ThousandSeparator := '.';
    Result := TryStrToFloat(lTexto, lNumero, lFormatSettings);

    if not Result then
    begin
      lFormatSettings.DecimalSeparator := '.';
      lFormatSettings.ThousandSeparator := ',';
      Result := TryStrToFloat(lTexto, lNumero, lFormatSettings);
    end;
  end;

  function IsDateOrDateTimeValue(const pValor: string): Boolean;
  var
    lData: TDateTime;
    lTexto: string;
  begin
    lTexto := Trim(pValor);

    if lTexto.IsEmpty then
      Exit(False);

    Result := TryStrToDateTime(lTexto, lData) or TryStrToDate(lTexto, lData);
  end;

begin
  CriarPlanilha;

  asm
    worksheet.columns = [
      { header: 'NOME', key: 'nome', style: { alignment: { horizontal: 'left' } } },
      { header: 'VALOR', key: 'valor', style: { alignment: { horizontal: 'left' } } },
      { header: 'DESCRIÇÃO', key: 'descricao', style: { alignment: { horizontal: 'left' } } }
    ];
  end;

  FormatarCabecalho;

  if Trim(pJsonConfiguracoes).IsEmpty then
    lArray := TJSArray.new
  else
    lArray := TJSArray(TJSJSON.parse(pJsonConfiguracoes));

  for lIndice := 0 to lArray.Length - 1 do
  begin
    lJsonObject := TJSObject(lArray[lIndice]);
    lRowObj := TJSObject.new;

    lNome := UpperCase(GetStringValue(lJsonObject, 'nome'));
    lDescricao := UpperCase(GetStringValue(lJsonObject, 'obs'));
    lValor := GetStringValue(lJsonObject, 'valor');

    lEhBooleano := GetStringValue(lJsonObject, 'tipo') = '2';

    if lEhBooleano then
      lValor := GetValorBooleano(lValor)
    else if SameText(lValor, 'NULL') then
      lValor := '';

    lCentralizarValor := lEhBooleano or IsNumericValue(lValor) or IsDateOrDateTimeValue(lValor);

    lRowObj['nome'] := lNome;
    lRowObj['valor'] := lValor;
    lRowObj['descricao'] := lDescricao;

    asm
      const lNovaLinha = worksheet.addRow(lRowObj);
      if (lCentralizarValor) {
        lNovaLinha.getCell('valor').alignment = { horizontal: 'center' };
      }
    end;
  end;

  BaixarPlanilha('exportacao_config_nfce.xlsx');
  TUtils.OcultarDivLoading;

  if Assigned(FExportacao) then
    FreeAndNil(FExportacao);
end;

procedure TExportacoes.FormatarCabecalho;
begin
  asm
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, size: 12, color: { argb: 'FFFFFF' }};
      cell.alignment = { horizontal: 'center'};
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '0054C3' }
      };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } }
      };
    });
  end;
end;

function TExportacoes.GetFieldProperty(pFieldName: string;
  pTipo: Boolean): string;
var
  lField: TField;
begin
  lField := FCdsDados.FieldByName(pFieldName);

  if pTipo then
  begin
    if lField.DataType = ftString then
      Result := 'string'
    else
      Result := 'outros';
  end
  else
    Result := lField.Size.ToString;
end;

function TExportacoes.GetJsonAlinharConteudo(pAlinhamento : string): TJSObject;
var
  lJsonAlinhamento : TJSObject;
begin
  Result := TJSObject.new;
  lJsonAlinhamento := TJSObject.new;
  lJsonAlinhamento['horizontal'] := pAlinhamento;

  Result['alignment'] := lJsonAlinhamento;
end;

function TExportacoes.GetNomeColuna(pTabela: TDBTableControl;
  pCampo: string): string;
var
  lIndice : Integer;
begin
  Result := pCampo.ToUpper;

  if pTabela <> nil then
  begin
    for lIndice := 0 to pTabela.Columns.Count - 1 do
    begin
      if pTabela.Columns[lIndice].DataField = pCampo then
      begin
        Result := pTabela.Columns[lIndice].Title.ToUpper;
        Break;
      end;
    end;
  end;
end;

function TExportacoes.GetStatusDispositivoWhatsApp(pStatus: string): string;
begin
  if StrToBool(pStatus) then
    Result := 'CONECTADO'
  else
    Result := 'DESCONECTADO';
end;

function TExportacoes.GetStatusMensagemWhatsApp(pStatus: string): string;
begin
  case StrToInt(pStatus) of
    0 : Result := 'PENDENTE';
    1 : Result := 'ENVIADA';
    2 : Result := 'ERRO';
    3 : Result := 'BLACK LIST';
  end;
end;

function TExportacoes.GetValorFloat(pField: TField; pValor: string): string;
begin
  Result := pValor;

  if TFloatField(pField).DisplayFormat <> '' then
  begin
    if (pField.FieldName = 'valor_total_faturamento') or (pField.FieldName = 'ticket_medio')  then
      Result := FormatFloat('#,##0.00', StrToFloat(pValor))
    else
      Result := FormatFloat('0.000', pField.AsFloat);
  end;
end;

function TExportacoes.GetValorFormatado(pValor, pCampo: string): string;
var
  lData: TDateTime;
  lField : TField;
  lFieldName : string;
begin
  Result := pValor.ToUpper;
  lField := FCdsDados.FieldByName(pCampo);
  lFieldName := lField.DisplayName.ToUpper;

  if lField.DataType = ftFloat then
    Result := GetValorFloat(lField, Result)
  else if (Pos('CPF', lFieldName) > 0) or (Pos('CNPJ', lFieldName) > 0) then
    Result := TUtils.FormatarCnpj_Cpf(Result)
  else if (Pos('TELEFONE', lFieldName) > 0) or (Pos('CELULAR', lFieldName) > 0) or
    (Pos('NUMERO_', lFieldName) > 0) then
  begin
    Result := TUtils.FormatarTelefone(Result);
  end
  else if (Pos('CEP', lFieldName) > 0) then
    Result := TUtils.FormatarCEP(Result)
  else if ((FCdsDados.EntitySetName.ToUpper = 'ALIADO') and (lFieldName = 'STATUS')) or
    (lFieldName = 'ALIADO.STATUS') then
  begin
    Result := TUtils.GetNomeStatusAliado(StrToInt(Result))
  end
  else if (FCdsDados.EntitySetName.ToUpper = 'PRODUTOS') and (lFieldName = 'STATUS') then
    Result := TUtils.GetNomeStatusProduto(StrToInt(Result))
  else if (FCdsDados.EntitySetName.ToUpper = 'CLIENTES') and (lFieldName = 'STATUS') then
    Result := TUtils.GetNomeStatusCliente(StrToInt(Result))
  else if (FCdsDados.EntitySetName.ToUpper = 'FORNECEDORES') and (lFieldName = 'STATUS') then
    Result := TUtils.GetNomeStatusFornecedor(StrToInt(Result))
  else if (FCdsDados.EntitySetName.ToUpper = 'WHATSAPP_MENSAGENS') and (lFieldName = 'STATUS') then
    Result := GetStatusMensagemWhatsApp(Result)
  else if lFieldName = 'WHATSAPP_INSTANCIAS.CONECTADO' then
    Result := GetStatusDispositivoWhatsApp(Result)
  else if lFieldName = 'PRECO_PADRAO' then
    Result := TUtils.GetPrecoPadraoProduto(StrToInt(Result)).ToUpper
  else if lFieldName = 'BANCO_FISCAL' then
  begin
    if Result = '1' then
      Result := 'SIM'
    else
      Result := 'NÃO';
  end
  else if lFieldName = 'MES_ANO' then
    Result := TUtils.FormatarMesAno(Result)
  else if (Pos('/', Result) > 0) and (Pos(':', Result) > 0)  then
  begin
    if TryStrToDateTime(Result, lData) then
      Result := FormatDateTime('dd/mm/yyyy hh:nn:ss', lData);
  end
  else if (Pos('/', Result) > 0) then
  begin
    if TryStrToDate(Result, lData) then
      Result := FormatDateTime('dd/mm/yyyy', lData);
  end
  else if Result = 'NULL' then
    Result := ''
  else if Result = 'TRUE' then
    Result := 'SIM'
  else if Result = 'FALSE' then
    Result := 'NÃO'
  else if lField.DataType = ftInteger then
  begin
    if not Result.IsEmpty then
      Result := TUtils.FormatarNumeroInteiro(StrToInt(Result));
  end;
end;

procedure TExportacoes.ProcessarDados;
var
  lNumeroRegistros : Integer;
begin
  FCdsDados.Close;

  FCdsDados.QuerySkip := FRegistrosProcessados;

  if (FRegistrosProcessados + cREGISTROS_PAGINACAO) > FQuantidadeRegistros then
  begin
    lNumeroRegistros := FQuantidadeRegistros - FRegistrosProcessados;
    FCdsDados.QueryTop := lNumeroRegistros;
    FRegistrosProcessados := FRegistrosProcessados + lNumeroRegistros;
  end
  else
  begin
    FCdsDados.QueryTop := cREGISTROS_PAGINACAO;
    FRegistrosProcessados := FRegistrosProcessados + cREGISTROS_PAGINACAO;
  end;

  FCdsDados.Load;
end;

procedure TExportacoes.SetCamposCds(pCdsOrigem : TXDataWebDataSet; pTabela : TDBTableControl);
var
  lIndice : Integer;
  lField: TField;
  lColumnsArray: TJSArray;
  lColuna: TJSObject;
  lNome: string;
begin
  lColumnsArray := TJSArray.new;
  FCdsDados.FieldDefs.Clear;

  for lIndice := 0 to pCdsOrigem.Fields.Count - 1 do
  begin
    lField := TFieldClass(pCdsOrigem.Fields[lIndice].ClassType).Create(FCdsDados);

    if pCdsOrigem.Fields[lIndice].Tag in [0, 3] then
    begin
      lField.FieldName := pCdsOrigem.Fields[lIndice].FieldName;
      lField.Size := pCdsOrigem.Fields[lIndice].Size;
      lField.DataSet := FCdsDados;
      lNome := lField.FieldName;
      lColuna := TJSObject.new;
      lColuna['header'] := GetNomeColuna(pTabela, lNome);
      lColuna['key'] := lNome;

      if lField.DataType = ftFloat then
      begin
        TFloatField(lField).DisplayFormat := TFloatField(pCdsOrigem.Fields[lIndice]).DisplayFormat;
        lColuna['style'] := GetJsonAlinharConteudo('right');
      end
      else if lField.DataType <> ftString then
        lColuna['style'] := GetJsonAlinharConteudo('center');

      lColumnsArray.push(lColuna);
      FListaCampos.Add(lNome);
    end;
  end;

  asm
    worksheet.columns = lColumnsArray;
  end;

  FormatarCabecalho;
end;

procedure TExportacoes.SetResumoFaturamentoExcel(pJson: TJSObject);
const
  cTitulosResumo : array[0..4] of String = ('QTDE. VENDAS', 'QTDE. MESES', 'FATURAMENTO TOTAL',
    'MÉDIA FATURAMENTO', 'MÉDIA TICKET MÉDIO');
  cCamposJson : array[0..4] of String = ('quantidade_vendas', 'quantidade_meses', 'faturamento_total',
    'media_faturamento', 'media_ticket_medio');
var
  lIndice : Integer;
  lTitulo,
  lValor : string;
begin
  asm
    worksheet.addRow({});
  end;

  for lIndice := Low(cTitulosResumo) to High(cTitulosResumo) do
  begin
    lTitulo := cTitulosResumo[lIndice];

    if lIndice < 2 then
      lValor := TUtils.FormatarNumeroInteiro(Integer(pJson[cCamposJson[lIndice]]))
    else
      lValor := string(pJson[cCamposJson[lIndice]]);

    asm
      var lastRow = worksheet.addRow({}); // linha vazia

      // Colocar o texto apenas na primeira coluna
      lastRow.getCell(1).value = lTitulo;
      lastRow.getCell(2).value = lValor;

      lastRow.getCell(1).font = { bold: true, size: 12, color: { argb: 'FFFFFF' }};
      lastRow.getCell(1).alignment = {horizontal: 'left'};
      lastRow.getCell(1).fill = {type: 'pattern',pattern: 'solid',fgColor: { argb: '0054C3' }};
      lastRow.getCell(1).border = {
        top: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } }};

      lastRow.getCell(2).font = { bold: true, size: 12, color: { argb: '000000' }};
      lastRow.getCell(2).alignment = {horizontal: 'right'};
    end;
  end;

  {lblQuantidadeVendas.Caption := TUtils.FormatarNumeroInteiro(Integer(pJson['quantidade_vendas']));
  lblQuantidadeMeses.Caption := TUtils.FormatarNumeroInteiro(Integer(pJson['quantidade_meses']));
  lblFaturamentoTotal.Caption := string(pJson['faturamento_total']);
  lblMediaFaturamento.Caption := string(pJson['media_faturamento']);
  lblMediaTicketMedio.Caption := string(pJson['media_ticket_medio']);}
end;

procedure TExportacoes.SetTextoColunaMesclada;
var
  lTotal : Integer;
  lTexto : string;
begin
  if FTextoColunaMesclada.IsEmpty then
    Exit;

  lTexto := FTextoColunaMesclada;
  lTotal := FListaCampos.Count;

  asm
    worksheet.addRow({});
    var lastRow = worksheet.addRow({}); // linha vazia
    var textoFinal = lTexto;     // coloque o texto desejado

    // Colocar o texto apenas na primeira coluna
    lastRow.getCell(1).value = textoFinal;

    // Mesclar da coluna 1 até a última coluna
    lastRow._worksheet.mergeCells(
       lastRow.number,       // linha atual
       1,                     // coluna inicial
       lastRow.number,        // mesma linha
       lTotal    // última coluna da planilha
    );
  end;

end;

end.
